import React, { useState } from 'react';
import './MobileContact.css';
import backgroundImage from '../../assets/basketball-bg.jpg';
import emailjs from '@emailjs/browser';

const MobileContact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');

    try {
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        subject: formData.subject,
        message: formData.message,
        to_email: 'basketballculturepodcast@gmail.com'
      };

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '',
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY || ''
      );

      setStatus('success');
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      console.error('Error sending email:', error);
      setStatus('error');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="mobile-contact-page">
      <div 
        className="mobile-contact-hero" 
        style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url(${backgroundImage})` }}
      >
        <h1 className="mobile-contact-title scroll-animate">
          CONTACT<br />US
        </h1>
      </div>

      <div className="mobile-contact-content scroll-animate">
        <div className="mobile-contact-info scroll-animate">
          <h2>Get In Touch</h2>
          <p>Have questions or want to be featured on the podcast? Reach out to us!</p>
          
          <div className="mobile-contact-details scroll-animate">
            <div className="mobile-contact-item scroll-animate">
              <i className="fas fa-envelope"></i>
              <span>basketballculturepodcast@gmail.com</span>
            </div>
            <div className="mobile-contact-item scroll-animate">
              <i className="fas fa-map-marker-alt"></i>
              <span>Sydney, Australia</span>
            </div>
          </div>
        </div>

        <form className="mobile-contact-form scroll-animate" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="subject"
            placeholder="Subject"
            value={formData.subject}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            required
            rows={4}
          ></textarea>
          <button 
            type="submit"
            disabled={status === 'sending'}
          >
            {status === 'sending' ? 'SENDING...' : 'SEND MESSAGE'} {status !== 'sending' && <i className="fas fa-paper-plane"></i>}
          </button>
          {status === 'success' && (
            <div className="success-message scroll-animate">Message sent successfully!</div>
          )}
          {status === 'error' && (
            <div className="error-message scroll-animate">Failed to send message. Please try again.</div>
          )}
        </form>
      </div>
    </div>
  );
};

export default MobileContact; 